module.exports = __webpack_public_path__ + "img/cirb.3b8b32db.png";